import React from "react";

const AboutUs: React.FC = () => {
  return (
    <div className="font-sans bg-gray-50 min-h-screen flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
      <div className="w-full max-w-6xl mx-auto p-8">
        <div className="text-center mb-12">
          <h1 className="text-5xl font-semibold text-gray-900">
            عن شركة زهران
          </h1>
          <p className="text-lg text-gray-700 mt-4 max-w-2xl mx-auto">
            نرحب بك في زهران، الشركة الرائدة في تقديم الخدمات المتنوعة. نقدم لك
            أفضل حلول السفر والراحة مع مجموعة من الخدمات التي تشمل حجز السيارات
            وتذاكر الرحلات والمزيد.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
          <div>
            <h2 className="text-3xl font-semibold text-gray-900">خدماتنا</h2>
            <ul className="list-inside pl-6 mt-4 space-y-3 text-gray-700">
              <li className="flex items-center">
                <span className="mr-2 inline-block w-2 h-2 rounded-full bg-blue-600"></span>
                حجز السيارات الخاصة والرحلات المتنوعة
              </li>
              <li className="flex items-center">
                <span className="mr-2 inline-block w-2 h-2 rounded-full bg-blue-600"></span>
                تقديم خدمات السفر المختلفة بأعلى جودة
              </li>
              <li className="flex items-center">
                <span className="mr-2 inline-block w-2 h-2 rounded-full bg-blue-600"></span>
                حجوزات للرحلات الداخلية والدولية
              </li>
              <li className="flex items-center">
                <span className="mr-2 inline-block w-2 h-2 rounded-full bg-blue-600"></span>
                تجربة مريحة وآمنة لعملائنا
              </li>
            </ul>
          </div>

          <div>
            <h2 className="text-3xl font-semibold text-gray-900">مهمتنا</h2>
            <p className="mt-4 text-gray-700">
              مهمتنا هي جعل تجربة السفر أكثر سلاسة وراحة. نحن نقدم خدماتنا عبر
              الإنترنت ليتمكن عملاؤنا من حجز السيارات وتذاكر الرحلات في أي وقت
              ومن أي مكان.
            </p>
            <p className="mt-4 text-gray-700">
              نعمل بجد لتقديم أعلى معايير الخدمة وضمان رضا عملائنا الكامل في كل
              خطوة من الرحلة.
            </p>
          </div>
        </div>

        <div className="mt-12 text-center">
          <h2 className="text-3xl font-semibold text-gray-900">
            لماذا تختارنا؟
          </h2>
          <p className="mt-4 text-lg text-gray-700 max-w-2xl mx-auto">
            اختر زهران لأننا نقدم لك تجربة حجز مريحة وسهلة مع خيارات متعددة
            لتلبية احتياجاتك. سواء كنت بحاجة لحجز سيارة أو تذكرة سفر، نحن هنا
            لضمان راحة بالك.
          </p>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
